import React from 'react'
import { titleToId } from '../utils/helpers'

const TEST_PRICES = {
  'enclomiphene': {
    'yearly': {
      'testosterone_pricing_variation_0': 99.99,
      'testosterone_pricing_variation_1': 99.99,
      'testosterone_pricing_variation_2': 79.99
    },
    'quarterly': {
      'testosterone_pricing_variation_0': 149.99,
      'testosterone_pricing_variation_1': 124.99,
      'testosterone_pricing_variation_2': 119.99
    },
    'monthly': {
      'testosterone_pricing_variation_0': 199.99,
      'testosterone_pricing_variation_1': 149.99,
      'testosterone_pricing_variation_2': 149.99
    }
  }, //  same as enclomiphene
  'ep': {
    'yearly': {
      'testosterone_pricing_variation_0': 99.99,
      'testosterone_pricing_variation_1': 99.99,
      'testosterone_pricing_variation_2': 79.99
    },
    'quarterly': {
      'testosterone_pricing_variation_0': 149.99,
      'testosterone_pricing_variation_1': 124.99,
      'testosterone_pricing_variation_2': 119.99
    },
    'monthly': {
      'testosterone_pricing_variation_0': 199.99,
      'testosterone_pricing_variation_1': 149.99,
      'testosterone_pricing_variation_2': 149.99
    }
  },  
  'oral-trt': {
    'yearly': {
      'testosterone_pricing_variation_0': 149.99,
      'testosterone_pricing_variation_1': 149.99,
      'testosterone_pricing_variation_2': 129.99
    },
    'quarterly': {
      'testosterone_pricing_variation_0': 199.99,
      'testosterone_pricing_variation_1': 174.99,
      'testosterone_pricing_variation_2': 169.99
    },
    'monthly': {
      'testosterone_pricing_variation_0': 249.99,
      'testosterone_pricing_variation_1': 199.99,
      'testosterone_pricing_variation_2': 199.99
    }
  },
  'trt-gel': {
    'yearly': {
      'testosterone_pricing_variation_0': 109.99,
      'testosterone_pricing_variation_1': 109.99,
      'testosterone_pricing_variation_2': 89.99
    },
    'quarterly': {
      'testosterone_pricing_variation_0': 159.99,
      'testosterone_pricing_variation_1': 134.99,
      'testosterone_pricing_variation_2': 129.99
    },
    'monthly': {
      'testosterone_pricing_variation_0': 209.99,
      'testosterone_pricing_variation_1': 159.99,
      'testosterone_pricing_variation_2': 159.99
    }
  },
  'injectable-trt': {
    'yearly': {
      'testosterone_pricing_variation_0': 99.99,
      'testosterone_pricing_variation_1': 99.99,
      'testosterone_pricing_variation_2': 79.99
    },
    'quarterly': {
      'testosterone_pricing_variation_0': 149.99,
      'testosterone_pricing_variation_1': 124.99,
      'testosterone_pricing_variation_2': 119.99
    },
    'monthly': {
      'testosterone_pricing_variation_0': 199.99,
      'testosterone_pricing_variation_1': 149.99,
      'testosterone_pricing_variation_2': 149.99
    }
  },
  'oral-trt-+-enclomiphene': {
    'yearly': {
      'testosterone_pricing_variation_0': 199.99,
      'testosterone_pricing_variation_1': 199.99,
      'testosterone_pricing_variation_2': 179.99
    },
    'quarterly': {
      'testosterone_pricing_variation_0': 249.99,
      'testosterone_pricing_variation_1': 224.99,
      'testosterone_pricing_variation_2': 219.99
    },
    'monthly': {
      'testosterone_pricing_variation_0': 299.99,
      'testosterone_pricing_variation_1': 249.99,
      'testosterone_pricing_variation_2': 249.99
    }
  }, // same as oral trt + enclomiphene
  'oral-trt+': {
    'yearly': {
      'testosterone_pricing_variation_0': 199.99,
      'testosterone_pricing_variation_1': 199.99,
      'testosterone_pricing_variation_2': 179.99
    },
    'quarterly': {
      'testosterone_pricing_variation_0': 249.99,
      'testosterone_pricing_variation_1': 224.99,
      'testosterone_pricing_variation_2': 219.99
    },
    'monthly': {
      'testosterone_pricing_variation_0': 299.99,
      'testosterone_pricing_variation_1': 249.99,
      'testosterone_pricing_variation_2': 249.99
    }
  },
  'trt-gel-+-enclomiphene': {
    'yearly': {
      'testosterone_pricing_variation_0': 189.99,
      'testosterone_pricing_variation_1': 189.99,
      'testosterone_pricing_variation_2': 169.99
    },
    'quarterly': {
      'testosterone_pricing_variation_0': 239.99,
      'testosterone_pricing_variation_1': 214.99,
      'testosterone_pricing_variation_2': 209.99
    },
    'monthly': {
      'testosterone_pricing_variation_0': 289.99,
      'testosterone_pricing_variation_1': 239.99,
      'testosterone_pricing_variation_2': 239.99
    }
  },
  'weight-loss': {
    monthly: {
      'weight_loss_pricing_q1_25_variation_0': 249.99,
      'weight_loss_pricing_q1_25_variation_1': 329.99,
      'weight_loss_pricing_q1_25_variation_2': 299.99
    }
  },
  'weight-loss-semaglutide': {
    monthly: {
      'weight_loss_pricing_q1_25_variation_0': 249.99,
      'weight_loss_pricing_q1_25_variation_1': 329.99,
      'weight_loss_pricing_q1_25_variation_2': 299.99
    }
  },
  'weight-loss-tirzepatide': {
    monthly: {
      'weight_loss_pricing_q1_25_variation_0': 399.99,
      'weight_loss_pricing_q1_25_variation_1': 449.99,
      'weight_loss_pricing_q1_25_variation_2': 429.99
    }
  },
  'blood-flow': {
    'monthly': {
      'bloodflow_pricing_q1_25_variation_0': 99.99,
      'bloodflow_pricing_q1_25_variation_1': 89.99,
      'bloodflow_pricing_q1_25_variation_2': 89.99
    }
  }, // same as blood flow
  'sexual': {
    'monthly': {
      'bloodflow_pricing_q1_25_variation_0': 99.99,
      'bloodflow_pricing_q1_25_variation_1': 89.99,
      'bloodflow_pricing_q1_25_variation_2': 89.99
    }
  }
}

const getPriceExperiment = (product, period, priceDefault, variant, integerOnly) => {
  let price = priceDefault

  if (TEST_PRICES[product]?.[period]?.[variant]) {
    price = `$${TEST_PRICES[product][period][variant]}`
  }

  if (integerOnly) {
    price = price.replace('.99', '')
  } 
  
  return price.replace('/mo', '')
}

export const isTestosteroneProduct = (title) => {
  const name = titleToId(title.toLowerCase().replace(' protocol', ''))
  const testosteroneProtocols = ['enclomiphene', 'ep', 'oral-trt', 'trt-gel', 'injectable-trt', 'oral-trt-+-enclomiphene', 'oral-trt+', 'trt-gel-+-enclomiphene', 'injectable-trt-+-hcg']
  return testosteroneProtocols.includes(name)
}

export const ProtocolPrice = ({ title, price, testosteroneVariant, bfVariant, wlVariant, period = 'yearly', integerOnly = false, htmlTemplate = false, htmlDefault = false }) => {
  const name = titleToId(title.toLowerCase().replace(' protocol', ''))
  let priceNew = price
  let priceNewFound = false

  if (testosteroneVariant && ['enclomiphene', 'ep', 'oral-trt', 'trt-gel', 'injectable-trt', 'oral-trt-+-enclomiphene', 'oral-trt+', 'trt-gel-+-enclomiphene'].includes(name)) {
    priceNew = getPriceExperiment(name, period, price, testosteroneVariant, integerOnly)
    priceNewFound = true
  }

  if (bfVariant && ['blood-flow', 'sexual'].includes(name)) {
    priceNew = getPriceExperiment(name, 'monthly', price, bfVariant, integerOnly)
    priceNewFound = true
  }

  if (wlVariant && ['weight-loss', 'weight-loss-semaglutide', 'weight-loss-tirzepatide'].includes(name)) {
    priceNew = getPriceExperiment(name, 'monthly', price, wlVariant, integerOnly)
    priceNewFound = true
  }

  if (htmlTemplate) {
    if (priceNewFound || htmlDefault) {
      priceNew = htmlTemplate.replace('_price_', priceNew)
    }
  }

  return <div dangerouslySetInnerHTML={{ __html: priceNew  }} />
}
